import { render, staticRenderFns } from "./symptom.vue?vue&type=template&id=4613fd1c&scoped=true&"
import script from "./symptom.vue?vue&type=script&lang=ts&"
export * from "./symptom.vue?vue&type=script&lang=ts&"
import style0 from "./symptom.vue?vue&type=style&index=0&id=4613fd1c&prod&lang=scss&scoped=true&"
import style1 from "./symptom.vue?vue&type=style&index=1&id=4613fd1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613fd1c",
  null
  
)

export default component.exports